var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["d-flex align-items-center", _vm.wrapperClass] },
    [
      _c(
        "b-form-checkbox",
        {
          staticClass: "show-ruler-checkbox",
          attrs: { inline: "" },
          on: { change: _vm.onShowRulerChange },
          model: {
            value: _vm.isRulerShown,
            callback: function ($$v) {
              _vm.isRulerShown = $$v
            },
            expression: "isRulerShown",
          },
        },
        [_vm._v("\n    Show ruler\n  ")]
      ),
      _vm._v(" "),
      _c("b-icon", {
        staticClass: "show-ruler-help cursor-pointer",
        attrs: { id: "rulerTooltip", icon: "question-circle" },
      }),
      _vm._v(" "),
      _c(
        "b-tooltip",
        { attrs: { target: "rulerTooltip", triggers: "hover" } },
        [
          _c("div", { staticClass: "ruler-tooltip" }, [
            _vm._v(
              "\n      Hover the cursor on the ruler and press the left mouse button to create a line.\n      "
            ),
            _c("br"),
            _vm._v(" Hover the cursor on the horizontal ruler and press "),
            _c("strong", [_vm._v("Shift + Left Mouse Button")]),
            _vm._v(" to remove the last added horizontal line.\n      "),
            _c("br"),
            _vm._v(" Hover the cursor on the vertical ruler and press "),
            _c("strong", [_vm._v("Shift + Left Mouse Button")]),
            _vm._v(" to remove the last added vertical line.\n    "),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.rulerLinesCount
        ? _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover.viewport.noninteractive",
                  value: `Reset lines`,
                  expression: "`Reset lines`",
                  modifiers: {
                    hover: true,
                    viewport: true,
                    noninteractive: true,
                  },
                },
              ],
              staticClass: "ml-2",
              attrs: { variant: "outline-primary", size: "sm" },
              on: { click: _vm.removeAllLines },
            },
            [_c("b-icon", { attrs: { icon: "arrow-clockwise" } })],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }